export default __webpack_public_path__ + "static/media/gallery_09.cd7a67d1.jpg";